/*!
 * AUTEUR UX Hardening — global defensive overlay
 * v1.1 — 2026-05-24: REMOVED button-disable on ATC submit (was preventing
 *                     theme's product-form web component from posting to /cart/add).
 *                     Switched to non-blocking timestamp debounce.
 *
 * Safe to load idempotently. Does not modify theme.js. Does not interfere
 * with the theme's own ATC submission logic.
 */
(function () {
  'use strict';
  if (window.__auteurUxInit) return;
  window.__auteurUxInit = true;

  // ============================================================
  // 0. Inject style for complimentary line items + focus rings
  // ============================================================
  var style = document.createElement('style');
  style.id = 'auteur-ux-hardening-style';
  style.textContent = [
    '.auteur-complimentary{display:inline-flex;align-items:center;gap:.4rem;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#847552;font-weight:500}',
    '.auteur-complimentary::before{content:"";display:inline-block;width:6px;height:6px;border-radius:50%;background:#847552}',
    '.auteur-complimentary-note{display:block;margin-top:.25rem;font-size:11px;color:#847552;font-weight:400;letter-spacing:0}',
    'body:not(.using-mouse) :focus-visible{outline:2px solid #847552;outline-offset:2px}',
    'newsletter-popup[open]{z-index:9999}',
    '@media (max-width:749px){newsletter-popup.modal[open]{align-items:flex-end!important}newsletter-popup.modal[open] > *{border-radius:16px 16px 0 0!important;max-width:100%!important;width:100%!important;animation:auteurSlideUp .35s ease}}',
    '@keyframes auteurSlideUp{from{transform:translateY(100%)}to{transform:translateY(0)}}',
    '.auteur-bundle-child{padding-left:1rem;border-left:2px solid #e5dfd5;margin-left:.5rem}',
    '.auteur-bundle-child::before{content:"+ COMPONENT";display:block;font-size:9px;letter-spacing:.18em;color:#847552;margin-bottom:.25rem}',
  ].join('\n');
  document.head.appendChild(style);

  document.addEventListener('mousedown', function () { document.body.classList.add('using-mouse'); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') document.body.classList.remove('using-mouse');
  });

  // ============================================================
  // 1. ATC double-click prevention — NON-BLOCKING timestamp debounce
  // ============================================================
  // Previous version disabled the submit button which conflicted with the
  // theme's <product-form> web component (it checks disabled state before
  // posting to /cart/add). This version only blocks rapid re-submits within
  // 800ms by checking a timestamp — the button stays interactive and the
  // theme's handler runs unimpeded.
  var lastSubmit = new WeakMap();
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var isCartAdd =
      (form.action && form.action.indexOf('/cart/add') !== -1) ||
      form.hasAttribute('data-pp-atc') ||
      form.closest('product-form') ||
      form.closest('buy-buttons');
    if (!isCartAdd) return;

    var now = Date.now();
    var last = lastSubmit.get(form) || 0;
    if (now - last < 800) {
      // Suspected double-click within 800ms — block this second submission.
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    lastSubmit.set(form, now);
  }, true);

  // ============================================================
  // 2. Quantity sanity — default blank/invalid to 1
  // ============================================================
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var qtyInputs = form.querySelectorAll('input[name="quantity"]');
    qtyInputs.forEach(function (input) {
      var val = parseInt(input.value, 10);
      if (!Number.isFinite(val) || val < 1) input.value = '1';
    });
  }, true);

  // ============================================================
  // 3. Label complimentary line items + visually group bundle components
  // ============================================================
  function labelComplimentary(root) {
    root = root || document;
    root.querySelectorAll('line-item:not([data-auteur-checked])').forEach(function (li) {
      li.dataset.auteurChecked = '1';
      var priceEl = li.querySelector('.line-item__line-price, .line-item__price');
      if (!priceEl) return;
      var text = priceEl.textContent.trim().replace(/[\s ]/g, '');
      var isFree = /^[$£€¥]?0(\.00)?$/i.test(text) || /^free$/i.test(text);
      if (!isFree) return;
      if (li.querySelector('.auteur-complimentary')) return;
      priceEl.innerHTML = '<span class="auteur-complimentary">Complimentary &middot; $0</span><span class="auteur-complimentary-note">A gift with your order.</span>';
    });

    if (!root.querySelector('line-item')) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        cart.items.forEach(function (item) {
          if (!item.properties) return;
          var bundleParent = item.properties._bundle_parent_id || item.properties._bundle_id_for_child || item.properties._bundle_parent_variant;
          if (!bundleParent) return;
          var key = item.key;
          var li = document.querySelector('line-item [data-line-item-key="' + key + '"], line-item[data-line-item-key="' + key + '"]');
          if (!li) {
            document.querySelectorAll('line-item').forEach(function (el) {
              var t = (el.querySelector('a.subheading, p.subheading') || {}).textContent;
              if (t && t.trim() === item.product_title && !el.dataset.auteurBundleChild) {
                el.dataset.auteurBundleChild = '1';
                el.classList.add('auteur-bundle-child');
              }
            });
          } else {
            li.dataset.auteurBundleChild = '1';
            li.classList.add('auteur-bundle-child');
          }
        });
      })
      .catch(function () {});
  }

  function runLabelComplimentaryDeferred() { setTimeout(function () { labelComplimentary(document); }, 60); }

  document.addEventListener('DOMContentLoaded', runLabelComplimentaryDeferred);
  document.addEventListener('cart:updated', runLabelComplimentaryDeferred);
  document.addEventListener('on:cart:updated', runLabelComplimentaryDeferred);
  document.addEventListener('cart:refresh', runLabelComplimentaryDeferred);

  if (window.MutationObserver) {
    var obs = new MutationObserver(function (mutations) {
      var shouldRun = false;
      mutations.forEach(function (m) {
        if (m.addedNodes.length) {
          for (var i = 0; i < m.addedNodes.length; i++) {
            var n = m.addedNodes[i];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('line-item')) { shouldRun = true; break; }
            if (n.querySelector && n.querySelector('line-item')) { shouldRun = true; break; }
          }
        }
      });
      if (shouldRun) runLabelComplimentaryDeferred();
    });
    document.addEventListener('DOMContentLoaded', function () {
      var targets = document.querySelectorAll('cart-drawer, main-cart, .cart, [data-cart], main');
      targets.forEach(function (t) { obs.observe(t, { childList: true, subtree: true }); });
    });
  }

  // ============================================================
  // 4. Newsletter popup — Esc + click-outside + focus return + exit-intent
  // ============================================================
  function setupNewsletter() {
    var pop = document.querySelector('newsletter-popup');
    if (!pop || pop.dataset.auteurHardened) return;
    pop.dataset.auteurHardened = '1';

    var lastFocus = null;
    var opened = pop.hasAttribute('open');
    var attrObs = new MutationObserver(function () {
      var isOpen = pop.hasAttribute('open');
      if (isOpen && !opened) {
        lastFocus = document.activeElement;
        opened = true;
        setTimeout(function () {
          var first = pop.querySelector('input, button, [href], select, textarea, [tabindex]:not([tabindex="-1"])');
          if (first) first.focus();
        }, 50);
      } else if (!isOpen && opened) {
        opened = false;
        if (lastFocus && typeof lastFocus.focus === 'function') {
          try { lastFocus.focus(); } catch (_e) {}
        }
      }
    });
    attrObs.observe(pop, { attributes: true, attributeFilter: ['open'] });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pop.hasAttribute('open')) pop.removeAttribute('open');
    });

    pop.addEventListener('click', function (e) {
      if (e.target === pop) pop.removeAttribute('open');
    });

    var isTouch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
    var alreadyShown = localStorage.getItem('theme:popup-shown') || localStorage.getItem('theme:popup-filled');
    if (!isTouch && !alreadyShown) {
      var triggered = false;
      document.addEventListener('mouseout', function (e) {
        if (triggered) return;
        if (e.clientY <= 0 && !e.relatedTarget && !e.toElement) {
          triggered = true;
          if (!pop.hasAttribute('open')) pop.setAttribute('open', '');
          localStorage.setItem('theme:popup-shown', 'true');
        }
      });
    }
  }
  document.addEventListener('DOMContentLoaded', setupNewsletter);

  // ============================================================
  // 5. Focus trap inside open dialogs/drawers (Tab cycling)
  // ============================================================
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var openHost = document.querySelector('newsletter-popup[open], cart-drawer[open], search-drawer[open], header-menu-drawer[open], header-menu-dropdown-sidebar[open], x-drawer[open], dialog[open]');
    if (!openHost) return;
    var focusable = openHost.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // ============================================================
  // 6. Screen reader announcements when cart updates
  // ============================================================
  var announce = function (msg) {
    var el = document.getElementById('status-announcement');
    if (!el) return;
    el.textContent = '';
    setTimeout(function () { el.textContent = msg; }, 60);
  };
  document.addEventListener('cart:added', function (e) {
    var title = (e.detail && e.detail.title) || 'Item added to cart';
    announce(title + ' added to cart.');
  });

  // ============================================================
  // 7. Prevent overlays from intercepting homepage tile clicks for first 1.5s
  // ============================================================
  if (document.body.classList.contains('template-index') || /\/(\?|$)/.test(location.pathname)) {
    var blockOverlays = function () {
      var pops = document.querySelectorAll('newsletter-popup[open]');
      pops.forEach(function (p) { p.removeAttribute('open'); });
    };
    setTimeout(function () { blockOverlays(); }, 250);
    setTimeout(function () { blockOverlays(); }, 1500);
  }

  // ============================================================
  // 8. aria-expanded sync for menu toggles
  // ============================================================
  function syncAriaExpanded() {
    if (!window.MutationObserver) return;

    var watch = function (el) {
      if (el.dataset.auteurAriaWatched) return;
      el.dataset.auteurAriaWatched = '1';
      var id = el.id;
      if (!id) return;
      var controllers = document.querySelectorAll('[aria-controls="' + id + '"]');
      if (!controllers.length) return;

      var update = function () {
        var open = el.hasAttribute('open') || el.classList.contains('is-active') || el.classList.contains('is-open') || el.classList.contains('open') || el.classList.contains('is-visible');
        controllers.forEach(function (c) { c.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      };
      update();
      new MutationObserver(update).observe(el, { attributes: true, attributeFilter: ['open', 'class', 'aria-hidden'] });
    };

    var selectors = [
      'cart-drawer',
      'search-drawer',
      'newsletter-popup',
      'header-menu-drawer',
      'header-menu-dropdown-sidebar',
      'header-menu-drawer-panel',
      'header-mega-menu',
      'x-drawer',
      'x-drawer-popover',
      'dialog',
      '[role="dialog"]',
    ].join(', ');

    document.querySelectorAll(selectors).forEach(watch);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches(selectors)) watch(n);
          if (n.querySelectorAll) n.querySelectorAll(selectors).forEach(watch);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('DOMContentLoaded', syncAriaExpanded);

  // ============================================================
  // 9. Keyboard nav: Escape closes any open dialog/drawer
  // ============================================================
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openHost = document.querySelector('cart-drawer[open], search-drawer[open], header-menu-drawer[open], header-menu-dropdown-sidebar[open], x-drawer[open]');
    if (!openHost) return;
    openHost.removeAttribute('open');
    if (typeof openHost.close === 'function') { try { openHost.close(); } catch (_) {} }
    if (typeof openHost.hide === 'function') { try { openHost.hide(); } catch (_) {} }
  });
})();